import { Navigation } from "Core/Navigation";
import { MenuService, ServiceProvider, TextBlockService } from "Service";
import { MenuItem } from "Service/Client";
import { computePosition, offset, shift } from "@floating-ui/dom";

/**
 * Handles the menu.
 * @hidden
 */
export class DMSMenu {
    /**
     * @hidden
     */
    public static menuItemTemplate: string = require("./Templates/MenuItem.html").default;

    public static toggle(): void {
        $("body").toggleClass("sidebar-enable");
        if ($(window).width() >= 768) {
            $("body").toggleClass("dms-navbar-mini");
        } else {
            $("body").removeClass("dms-navbar-mini");
        }
        localStorage["dms-menu-state"] = $("body").hasClass("dms-navbar-mini");
        this.toggleMenuDisabled(localStorage["dms-menu-state"] == "true");
    }

    private static toggleMenuDisabled(disabled: boolean) {
        if (disabled) {
            $(".dms-menu-main").find(".dms-menu-link").attr("aria-disabled", "true");
            $(".dms-menu-main").find("[aria-expanded='true']").attr("aria-expanded", "false");
            $(".dms-menu-main").find(".mm-active").removeClass("mm-active");
            $(".dms-menu-main").find(".mm-show").removeClass("mm-show");
        } else {
            $(".dms-menu-main").find(".dms-menu-link").removeAttr("aria-disabled");
        }
    }

    private static activeLi: JQuery;

    private static addMenu(textBlockService: TextBlockService, items: MenuItem[], parentUl: JQuery, level: number) {
        const menuItemTemplate = kendo.template(this.menuItemTemplate, { useWithBlock: false });
        for (const item of items) {
            let url = (item.Href || "#").replace("~", "");
            if (url != "#") {
                url = Navigation.getUrl(url, false);
            }
            let isActive = window.location.pathname.toLowerCase() == url.toLowerCase();

            const menuText = ServiceProvider.current.TextBlock.get(item.TextBlockModule, "menu");

            const li = $(
                menuItemTemplate({
                    level: level,
                    url: url,
                    menuText: menuText,
                    icon: item.Icon,
                    openNewWindow: item.OpenInNewWindow ? "true" : "",
                    urlMode: item.HrefMode,
                })
            ).appendTo(parentUl);

            if (level > 1) {
                li.addClass("dms-menu-sub");
            }
            if (isActive) {
                this.activeLi = li;
                this.activeLi.parentsUntil(".dms-menu-main", "li").children("a").attr("aria-expanded", "true");
                this.activeLi.parentsUntil(".dms-menu-main", "li").addClass("mm-active");
                this.activeLi.children("a").addClass("mm-active-link");
                this.activeLi.addClass("mm-active");
            }

            if (item.Items && item.Items.length) {
                $(`<span class="far fa-chevron-up dms-menu-arrow"></span>`).appendTo(li.find(">.dms-menu-link"));
                if (level > 1) {
                    $(`<span class="far fa-chevron-right dms-menu-arrow-mini"></span>`).appendTo(li.find(">.dms-menu-link"));
                }
                let ul = $(`<ul class="dms-menu-sublist">`).appendTo(li);
                this.addMenu(textBlockService, item.Items, ul, level + 1);
            }
        }
    }

    private static visibileUl: { [level: number]: JQuery } = {};

    /**
     * Initializes the menu.
     */
    public static async initialize(menuService: MenuService, textBlockService: TextBlockService): Promise<void> {
        let menu = await menuService.get();

        await textBlockService.getAll();
        $(".dms-sidemenu-container").removeClass("dms-hidden") /*.addClass("animated fadeIn")*/;

        const userMenu = $(".dms-user");
        const userPopup = $(".dms-user-popup");

        userMenu.on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            userPopup.show();

            $(document).one("click", () => userPopup.hide());

            computePosition(userMenu[0], userPopup[0], {
                middleware: [offset({ mainAxis: 4 }), shift({ padding: 4 })],
                placement: "bottom-end",
            }).then(({ x, y }) => {
                userPopup.css({ top: y, left: x });
            });
        });
        userMenu.on("blur", () => {
            userPopup.hide();
        });

        let menuContainer = $(".dms-menu-main");
        if (menuContainer.length) {
            this.addMenu(textBlockService, menu.Value, menuContainer, 1);
            menuContainer.metisMenu({});
            menuContainer.on("click", "a", null, (e: JQuery.ClickEvent) => {
                e.preventDefault();
                this.openItem($(e.target).closest("a"));
            });
            $(".dms-menu-container").removeClass("dms-hidden") /*.addClass("animated fadeIn")*/;

            this.toggleMenuDisabled(localStorage["dms-menu-state"] == "true");
        }

        $(".dms-menu-main").on("mouseenter", "li", (e) => {
            if (!$("body").hasClass("dms-navbar-mini")) {
                return;
            }
            const li = $(e.currentTarget);
            const level = li.data("dms-menu-level");
            const ul = li.find(">ul");

            const a = li.find(">a:first");

            li.one("mouseleave", () => {
                setTimeout(() => {
                    if (!li.is(":hover")) {
                        ul.removeClass("mm-show");
                        ul.css({ position: "", top: "", left: "", width: "", height: "" });
                        a.removeClass("active").removeClass("active-level-1");
                    }
                }, 350);
            });

            if (this.visibileUl[level]) {
                this.visibileUl[level].find(">a:first").removeClass("active").removeClass("active-level-1");
                const oldUl = this.visibileUl[level].find(">ul");
                oldUl.removeClass("mm-show");
                oldUl.css({ position: "", top: "", left: "", width: "", height: "" });
                this.visibileUl[level] = null;
            }
            this.visibileUl[level] = li;
            ul.addClass("mm-show");
            ul.css({ position: "absolute", width: "350px", height: "" });

            a.addClass("active");
            if (level == 1) {
                a.addClass("active-level-1");
            }

            const refElement = level == 1 ? a : li;

            if (ul.length > 0) {
                computePosition(refElement[0], ul[0], {
                    placement: level == 1 ? "bottom-end" : "right-start",
                }).then(({ x, y }) => {
                    ul.css({ top: y, left: x, position: "absolute" });
                });
            }
        });

        $(".dms-mobile-toggle").on("click", () => {
            $("body").addClass("open");
        });

        $(".dms-mobile-toggle-close").on("click", () => {
            $("body").removeClass("open");
        });
    }

    private static openItem(item: JQuery<Element>, forceNewWindow: boolean = false): boolean {
        let openInNewWindow = item.attr("data-dms-menuopen") == "true";
        let urlMode = item.attr("data-dms-menumode");
        let url = item.attr("href");
        let li = item.closest("li");

        if (url && url != "#") {
            $(".mm-active").removeClass("mm-active");
            $(".mm-active-link").removeClass("mm-active-link");
            li.addClass("mm-active");
            item.addClass("mm-active-link");
            li.parentsUntil(".metismenu").addClass("mm-active");
            const ulLevel1 = $(".active-level-1");
            ulLevel1.removeClass("active").removeClass("active-level-1");

            if (openInNewWindow || forceNewWindow) {
                Navigation.openWindow(url, urlMode);
            } else {
                Navigation.navigate(url);
            }
            $("body").removeClass("open");

            return false;
        }
        return true;
    }
}
